import { RoutineTriggerConfig } from './routineTriggerConfig';

export interface CounterRoutineTriggerConfig extends RoutineTriggerConfig {
  onInterval?: number;
  ceiling?: number;
  floor?: number;
}
